import React, { Component } from "react";
import { postRequest, withRequest } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import { apiUrl } from "../../../utils/apiUrl";
import Loader from "../../general/Loader";
import Create from "./Create";
import Modal from "../../general/Modal";
import Pagination from "../../general/Pagination";
import dayjs from "dayjs";
import { debounce } from "lodash";
import { Link } from "react-router-dom";
import { formatNumber, getLink } from "../../../utils/helpers";
import Select from "react-select";
import { armarMovimientos, filtrarMovimientos, TablaMovimientos } from "./movimientos";

const queryDeFiltros = (filtros) =>
	Object.keys(filtros)
		.map((fil) => `${fil}=${filtros[fil]}`)
		.join("&");

class Ajustes extends Component {
	state = {
		ajustes: [],
        movimientos: [],
		showCreate: false,
		loading: true,
		filtros: {
            hasta: dayjs().format("YYYY-MM-DD"),
            reporte: "operaciones-inventario",
        },
		filtrosQuery: "",
		filtro: "",
	};
	componentDidMount() {
		this.getAjustesFiltrados();
	}

	getAjustes = async (url = null) => {
		const id = this.props.producto.id;
		url = url ? url : `reportes?productos=${id}&reporte=operaciones-inventario`;
		const respuesta = await this.props.request(url);
		const producto = respuesta.data?.find((p) => p.id === id);
		const movimientos = producto ? armarMovimientos(producto) : [];

		this.setState({
			ajustes: filtrarMovimientos(movimientos, this.state.filtro),
			movimientos,
			loading: false,
		});
	};
	removeAjuste = async (event, ajuste) => {
		event.preventDefault();

		const response = await postRequest(apiUrl(`ajustes/${ajuste}`), {}, 'delete');

		if (response.success) {
			this.getAjustes();
			this.props.getProducto();
			return;
		} else {
			this.setState({ errors: response.data.message });
		}

		this.setState({ loading: false });
	};
	toggleCreateModal = () => {
		this.setState({
			showCreate: !this.state.showCreate,
		});
	};
	// `await this.setState()` no espera al re-render: setState no devuelve una
	// promesa, así que la continuación se reanudaba antes de que React
	// aplicara el update y `this.state.filtros` tenía los filtros anteriores.
	// Por eso cada consulta salía un filtro atrás y el primer intento no
	// filtraba nada. El estado se actualiza con la forma funcional y la consulta
	// se lanza en el callback de setState, que sí corre después del commit.
	onFiltroChange = (value, filtro) => {
		// Buscar y Operación filtran lo ya cargado, y el filtro se conserva al
		// cambiar las fechas.
		if (filtro === 'buscar' || filtro === 'incrementar') {
			const valor = value === 'todos' ? '' : value;
			this.setState(prevState => ({
				filtro: valor,
				ajustes: filtrarMovimientos(prevState.movimientos, valor),
			}));
			return;
		}

		this.setState((state) => {
			const filtros = { ...state.filtros, [filtro]: value };

			return { filtros };
		}, this.buscarConFiltros);
	};
	// El debounce va sobre la petición, no sobre el cambio de filtro: `debounce`
	// era uno solo para todos los campos, y cambiar dos filtros en menos de 500ms
	// descartaba el primero junto con su valor.
	buscarConFiltros = debounce(() => {
		this.getAjustesFiltrados();
	}, 500);

	getAjustesFiltrados = () => {
		const id = this.props.producto.id;
		const query = queryDeFiltros(this.state.filtros);

		this.setState({ filtrosQuery: `?${query}` });

		this.getAjustes(`reportes?productos=${id}&${query}`);
	};
	render() {
		const { producto } = this.props;
		const { ajustes, loading, meta, links } = this.state;

		if (loading === true) {
			return <Loader />;
		}
		return (
			<div className='page-controls'>
				<div className="row justify-content-end pr-3">
					<div className="col-md-3 pr-0 pl-4">
						<label htmlFor="desde">DESDE</label>
						<input
							type="date"
							name="desde"
							id="desde"
							className="form-control"
							onChange={(e) =>
								this.onFiltroChange(e.target.value, "desde")
							}
						/>
					</div>
					<div className="col-md-3">
						<label htmlFor="hasta">HASTA</label>
						<input
							type="date"
							name="hasta"
							id="hasta"
							defaultValue={dayjs()
								.endOf("day")
								.format("YYYY-MM-DD")}
							className="form-control"
							onChange={(e) =>
								this.onFiltroChange(e.target.value, "hasta")
							}
						/>
					</div>
				</div>
				<div className="table-data__tool">
					<div className="table-data__tool-left row">
						<div className="col-md-2">
							<label htmlFor="existencia">EN INVENTARIO</label>
							<input
								type="text"
								id="existencia"
								value={producto.cantidad === null ? "∞" : formatNumber(producto.cantidad)}
								className="form-control"
								readOnly
							/>
						</div>
						<div className="col-md-4 px-0">
							<label htmlFor="existencia">BUSCAR</label>
							<input
								type="text"
								id="buscar"
								className="form-control"
                                onChange={(e) =>
									this.onFiltroChange(e.target.value, "buscar")
								}
							/>
						</div>
						<div className="col-md-2 pr-0">
							<label htmlFor="incrementar">Operación</label>
							<Select
								name="incrementar"
								id="incrementar"
								onChange={(e) =>
									this.onFiltroChange(e.value, "incrementar")
								}
								defaultValue={{
									value: "todos",
									label: "Todas",
								}}
								options={[
									{ value: "todos", label: "Todas" },
									{
										value: "ENTRADA",
										label: "ENTRADA",
									},
									{ value: "SALIDA", label: "SALIDA" },
								]}
							/>
						</div>

						<div className="col-md-4 d-flex justify-content-around align-items-end pt-4">
							<Link
								to={getLink(
									`/imprimir/reportes?productos=${
										producto.id
									}&${this.state.filtrosQuery.substring(1)}`
								)}
								target="_blank"
								className="au-btn au-btn-icon au-btn-filter m-r-20"
								style={{flex: 1, textAlign: 'center'}}
							>
								<i className="zmdi zmdi-print"></i> Imprimir
							</Link>
                            {producto.tipo === 'producto' && (
                                <>
                                    <button
                                        onClick={this.toggleCreateModal}
                                        className="au-btn au-btn-icon au-btn--green au-btn--small m-r-15 mt-2 mt-lg-0"
                                        style={{width: '45%'}}
                                        disabled={!producto.inventariable}
                                    >
                                        <i className="zmdi zmdi-plus" />
                                        Nuevo Ajuste
                                    </button>
                                </>
                            )}
						</div>
					</div>
				</div>
				{ajustes.length > 0 ? (
					<TablaMovimientos movimientos={ajustes} inventariable={producto.inventariable} />
				) : (
					<div>No hay ningún ajuste realizado.</div>
				)}

				{meta && (
					<Pagination
						links={links}
						meta={meta}
						getData={this.getAjustes}
					/>
				)}

				<Modal
					show={this.state.showCreate}
					blank={true}
					toggle={this.toggleCreateModal}
				>
					<Create
						toggle={this.toggleCreateModal}
						producto={producto}
						getAjustes={this.getAjustesFiltrados}
						getProducto={this.props.getProducto}
					/>
				</Modal>
			</div>
		);
	}
}

export default withRequest(Ajustes);
